import { ResponsesPensionItemResponse } from '@genial/services/dist/models';

import { validateAndFormatValue } from '../../Table/constants';
import { messageError } from '../Fund/constants';

export const parsePlanDetailsData = (item: ResponsesPensionItemResponse) => {
  const implantationDate = validateAndFormatValue(item?.implantationDate, 'date');
  const data = [
    { label: 'Plano', value: item?.plain?.name || messageError },
    { label: 'Certificado', value: item?.number || messageError },
    { label: 'Susep', value: item?.plain?.susep || messageError },
    { label: 'Seguradora', value: item?.plain?.insurerName || messageError },
    { label: 'Forma de pagamento', value: item?.payment?.form || messageError },
    { label: 'Data de implantação', value: implantationDate },
    { label: 'Tributação', value: item?.taxationRegime || messageError },
    { label: 'Periodicidade', value: item?.payment?.frequency || messageError },
  ];

  return data;
};
